export default "__VITE_ASSET__D2ZFrng1__"